import styled from 'styled-components';
import { customTextColor } from '../../../constants/CommonStyles';

export const P = styled.p`
  line-height: 1.2;
  ${customTextColor}
`;
